import storage from 'redux-persist/lib/storage';

import { PERSIST_STORAGE_KEY } from '../constants';

const INITIAL_REDUCERS = {
  blacklist: {
    appready: false,
    draft: null,
    editMode: null,
    filters: [],
    loading: false,
    markers: [],
    modal: null,
    navigation: null,
  },
  whitelist: {
    demo: true,
    done: [],
    lastActivity: Date.now(),
    lastCenter: [],
  },
};

export const reduxPersistConfig = {
  blacklist: Object.keys(INITIAL_REDUCERS.blacklist),
  key: PERSIST_STORAGE_KEY,
  storage,
  whitelist: Object.keys(INITIAL_REDUCERS.whitelist),
};

export const getInitialState = () => {
  const { blacklist, whitelist } = INITIAL_REDUCERS;
  const initialState = { ...whitelist, ...blacklist };
  return initialState;
};
